import { defineStore } from 'pinia';
import { ref } from 'vue';
import { balanceApi, type BalanceResponse } from '../api/balance';

export const useBalanceStore = defineStore('balance', () => {
  const data = ref<BalanceResponse | null>(null);
  const loading = ref(false);
  const error = ref<string | null>(null);

  async function load(): Promise<void> {
    loading.value = true;
    error.value = null;
    try {
      data.value = await balanceApi.get();
    } catch (err) {
      error.value = (err as Error).message;
    } finally {
      loading.value = false;
    }
  }

  return { data, loading, error, load };
});
